import Axios from 'axios';
import moment from 'moment-timezone';
import { protectedResources } from '../authConfig';

//const getAccessToken  = sessionStorage.getItem('AccessToken');
const URL =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/AdvanceSalary/GetAnnouncements';
const URL_BACKEND =
  protectedResources.apiHRMobile.baseApi + '/api/v1/BackOffice/GetAnnouncements';
const URL_CRATE =
  protectedResources.apiHRMobile.baseApi + '/api/v1/BackOffice/SetAnnouncement';
const URL_EDIT =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/BackOffice/SetAnnouncementUpdate';
const URL_DEL =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/BackOffice/SetAnnouncementDelete';
let tokenKey;

export async function getAnnouncementList(
  offset = 0,
  limit = 3,
  pages = 'main',
) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };
  let bodyParameters = {};
  if (pages === 'dashboard') {
    bodyParameters = {
      offset: offset,
      limit: limit,
      statusStr: 'Active',
    };
  } else {
    bodyParameters = {
      offset: offset,
      limit: limit,
    };
  }

  // const response = await Axios.post(URL,bodyParameters,config);
  // console.log('response=',response);
  //return false;

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response.data;
  } catch (error) {
    console.error(error);
  }
}
export async function getBackendAnnouncementList(filter) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {
    month: 0,
    offset: parseInt(filter.offset),
    limit: parseInt(filter.perpage),
    subject: filter.subject,
  };

  try {
    const response = await Axios.post(URL_BACKEND, bodyParameters, config);
    return await response.data;
  } catch (error) {
    console.error(error);
  }
}
export async function EditAnnouncement(formInput) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  var formData = new FormData();
  //console.log('formInput = ',formInput);
  formData.append('id', formInput.id);
  formData.append('subjectTh', formInput.subjectTh);
  formData.append('subjectEn', formInput.subjectEn);
  formData.append('detailsTh', formInput.detailsTh);
  formData.append('detailsEn', formInput.detailsEn);
  formData.append('shortDetailsEn', formInput.shortDetailsEn);
  formData.append('shortDetailsTh', formInput.shortDetailsTh);
  formData.append(
    'publishedDateTime',
    moment(formInput.publishedDateTime)
      .subtract(7, 'h')
      .format('yyyy-MM-DDTHH:mm'),
  );
  formData.append('status', formInput.status);
  formData.append('File', formInput.File);
  // console.log('formDataEdit = ',formData);
  const config = {
    headers: {
      Authorization: `Bearer ${tokenKey}`,
      'Content-Type': 'multipart/form-data',
    },
  };
  try {
    const response = await Axios.post(URL_EDIT, formData, config);
    return await response;
  } catch (error) {
    console.error(error);
    return error.response;
  }
}
export async function CreateAnnouncement(formInput) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  var formData = new FormData();
  //console.log('formInput = ',formInput);
  formData.append('id', '0');
  formData.append('subjectTh', formInput.subjectTh);
  formData.append('subjectEn', formInput.subjectEn);
  formData.append('detailsTh', formInput.detailsTh);
  formData.append('detailsEn', formInput.detailsEn);
  formData.append('shortDetailsEn', formInput.shortDetailsEn);
  formData.append('shortDetailsTh', formInput.shortDetailsTh);
  formData.append(
    'publishedDateTime',
    moment(formInput.publishedDateTime)
      .subtract(7, 'h')
      .format('yyyy-MM-DDTHH:mm'),
  );
  formData.append('status', formInput.status ? 1 : 0);
  formData.append('File', formInput.File);
  // console.log('formDataCreate = ',formData);
  const config = {
    headers: {
      Authorization: `Bearer ${tokenKey}`,
      'Content-Type': 'multipart/form-data',
    },
  };
  try {
    const response = await Axios.post(URL_CRATE, formData, config);
    return await { url: response.data };
  } catch (error) {
    console.error(error);
  }
}
export async function DelAnnouncement(formInput) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const bodyParameters = {
    id: formInput.id,
  };
  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };
  try {
    const response = await Axios.delete(
      URL_DEL + '?id=' + formInput.id,
      config,
    );
    return await { url: response.data };
  } catch (error) {
    console.error(error);
  }
}
